import React from "react"
import tw, { styled } from "twin.macro"
//import { Link } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

import { DrupalLink } from "../../utils/drupal"

const DualTile = ({ r: { tiles }, ...props }) => {
  return (
    <Style className="promotion promotion--dual-tile" {...props}>
      {tiles.map((tile, i) => (
        <article key={i}>
          {tile.r.image && (
            <GatsbyImage
              image={getImage(tile.r.image.r.media.file.sharp)}
              {...tile.r.image.meta}
              className="promotion__image"
              objectFit="cover"
              objectPosition={"center"}
            />
          )}
          <div className="promotion__body">
            <strong>{tile.title}</strong>
            {tile.body && (
              <div
                tw="space-y-2"
                dangerouslySetInnerHTML={{ __html: tile.body.html }}
              />
            )}
            {tile.link && (
              <ul tw="flex justify-end items-center list-none mb-0">
                {tile.link.map((link) => (
                  <li key={link.uri}>
                    <DrupalLink to={link.uri}>{link.title}</DrupalLink>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </article>
      ))}
    </Style>
  )
}
export default DualTile

const Style = styled.div`
  ${tw`
        flex
        flex-wrap
        mt-20!
        justify-center
        gap-y-8
    `}

  article {
    ${tw`max-w-2xl border lg:max-w-full lg:flex-1`}
  }

  .promotion__body {
    ${tw`
            z-20
            px-4
            bg-white
            bg-opacity-80
            [backdropFilter:blur(4px)]
            sm:bg-opacity-100
            flex
            flex-wrap
            gap-2
            lg:gap-5
            items-center
            w-auto
            lg:[fontSize:2.015ch]
            xl:[fontSize:1.625ch]
            mg:[fontSize:1.95ch]
            justify-center
            text-center
        `}

    ul {
      ${tw`m-0`}
    }

    p,
    li {
      ${tw`mb-0`}
    }

    ul a {
      ${tw`
                border
                border-solid
                border-primary
                rounded-3xl
                px-5
                py-2
                inline-block
                leading-none
                whitespace-nowrap
                bg-primary
                text-white
                font-semibold
                text-base
                hover:bg-black
                hover:border-black
                transition-colors
            `}
    }
  }

  * + .promotion__body {
    ${tw`mt-4`}
  }

  .promotion__image {
    ${tw`block [aspectRatio:22 / 9]`}
  }
`
